<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      class="mb-6"
      v-model="form.stdInfo"
      :board="this.board"
      :date-readonly="false"
      :is-print="isPrint" />


    <!-- 현장개요 -->
    <div class="mb-5">
      <h5 class="mb-5"><i class="dot"></i> 현장개요</h5>
      <div class="writeGridContainer">
        <div class="writeGridCol2">
          <div>사업명</div>
          <ml-input v-model="form.사업명" />
        </div>
        <div></div>
        <div>
          <div>업체명</div>
          <ml-input v-model="form.업체명" />
        </div>
        <div>
          <div>점검자</div>
          <ml-input v-model="form.점검자" />
        </div>
        <div>
          <div>점검일시</div>
          <date-selector v-model="form.점검일시" />
        </div>
      </div>
    </div>

    <!-- 점검종류 -->
    <div class="mb-6">
      <h5 class="mb-5"><i class="dot"></i> 점검종류</h5>
      <div class="grid grid-cols-6 gap-x-6 gap-y-4 mt-4">
        <div class="col-span-1 flex items-center">
          <span class="flex">
            <vs-radio :readonly="board.readonly" v-model="form.점검종류" vs-name="점검종류" vs-value="순회점검">순회점검</vs-radio>
          </span>
        </div>
        <div class="col-span-1 flex items-center">
          <span class="flex">
            <vs-radio :readonly="board.readonly" v-model="form.점검종류" vs-name="점검종류" vs-value="합동점검">합동점검</vs-radio>
          </span>
        </div>
      </div>
    </div>

    <!-- 점검분야 -->
    <div class="mb-6">
      <h5><i class="dot"></i> 점검분야</h5>

      <div class="grid grid-cols-6 gap-x-6 gap-y-4 mt-4">
        <div v-for="_title in inspectionTitle" :key="_title" class="col-span-1 flex items-center">
          <div v-if="isPrint" class="flex items-center">
            <div v-if="form.inspectChecked.includes(_title)" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
              <vs-icon icon="check" size="x-small"></vs-icon>
            </div>
            <div v-else style="border: 2px solid rgb(180, 180, 180)" class="w-5 h-5 rounded-sm mr-2"></div>
            <span class="flex-1">
              {{ _title }}
            </span>
          </div>
          <div v-else>
            <span class="flex">
              <vs-checkbox :readonly="board.readonly" v-model="form.inspectChecked" :vs-value="_title">{{ _title }}</vs-checkbox>
            </span>
          </div>
        </div>
      </div>
    </div>

    <table-inspect-merge
      v-for="(_title, _title_i) in inspectionTitle"
      :key="`inspect_${_title}`"
      v-show="form.inspectChecked.includes(_title)"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :title="_title"
      :table-header-title="'점검사항'"
      :table-header-check="[{ text: '적정' }, { text: '미흡' }, { text: '해당없음' }]"
      :tableHeaderNote="[{ text: '문제점', width: '320px' }, { text: '개선내용', width: '320px'}]"
      contentBefore="•"
      v-model="form[`inspectList_${_title_i + 1}`]"
      class="mt-5"
    />

    <!-- 참석자 명단 -->
    <table-custom
      :controls="true"
      :multiple="true"
      :board="board"
      :is-print="isPrint"
      title="참석자 명단"
      :tableData="[
        { id: 'id', title: '연번', type: 'no', placeholder: '', width: '50px' },
        { id: '소속', title: '소속', type: 'text', placeholder: '' },
        { id: '직위', title: '직위', type: 'text', placeholder: '' },
        { id: '성명', title: '성명', type: 'text', placeholder: '' },
        { id: '서명', title: '서명', type: 'sign', placeholder: '' },
      ]"
      :mobile="['target', 'name']"
      v-model="form.employeeList"
      class="mt-4"
      :button-add-name="'참석자 등록'"
    />

    <!-- 결재란 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i> 결재란</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--파일첨부-->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" class="mt-28px" :is-print="isPrint" />

  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule';
import DateSelector from "@/components/selector/DateSelector.vue";
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import * as inspectData from "./inspectData";
import TableCustom from "@/components/TableCustom.vue";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";

export default {
  components: {
    NameWithSignatureRow,
    TableCustom,
    TableInspectMerge,
    DateSelector,
    FileUploadModule,
    PhotoUploadGridModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: ["시설관리", "청소(미화)", "조리(급식실)"],
      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],
        "사업명": "",
        "업체명": "",
        "점검자": "",
        "점검일시": "",
        "점검종류": "",

        inspectChecked: [],
        inspectList_1: inspectData.inspectTable_1,
        inspectList_2: inspectData.inspectTable_2,
        inspectList_3: inspectData.inspectTable_3,

        employeeList: [],



        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },
      },
    };
  },
  methods: {
    onSelectFieldSelector (value) {
      this.form.학교명 = value.field_name;
    }
  },
};
</script>

<style scoped lang="scss">
</style>
